@import "../../../../../../../shared/styles/base";

.c-image-uploader-label__size-hint {
  font-weight: normal;
}

.dropzone {
  background-color: rgba($ds-neutral-50, 50%);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: 1.5px dashed $ds-neutral-200;
  border-radius: 0.25rem;
  margin-top: 0.25rem;
  position: relative;
  width: 100%;
  max-height: 18rem;
  height: 18rem;
}

.uploadFailed {
  border: solid 2px $ds-coral-600;
  border-radius: 0;
}

.altField {
  margin-top: 1rem;
}

.container {
  position: relative;
}

.container.insertImageContainer {
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-width: 100%;
  }
}

.container .dropzone {
  display: none;
}

.container:hover .dropzone,
.container:focus .dropzone {
  display: block;
  position: absolute;
  top: 0;
  max-height: 100%;
  height: 100%;
  margin: 0;
  border: none;
  border-radius: 0;
  background-color: rgba($ds-neutral-50, 75%);
}
